module.exports = __webpack_public_path__ + "static/media/LIBON.25fd5930.svg";